import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, MenuController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/core/authentication/services/auth.service';
import { ClientConfigurationService } from 'src/app/core/client-configuration/client-configuration.service';
import { ConfigSettings } from 'src/app/core/client-configuration/config-settings.enum';
import { ConnectionService } from 'src/app/core/connection/connection.service';
import { SyncService } from 'src/app/core/sync/sync.service';

interface MainHeaderRoute {
	id: number;
	text: string;
	url: string;
	icon: string;
}

@Component({
	selector: 'app-main-header',
	templateUrl: './main-header.component.html',
	styleUrls: ['./main-header.component.scss'],
})
export class MainHeaderComponent implements OnInit {

	@Input()
	pageTitle: string;

	mainMenuId = 'main-menu';
	routes = [
		{
			id: 1,
			text: 'Appointments',
			url: '/appointments',
			icon: 'bookmark-outline',
		},
	] as MainHeaderRoute[];

	constructor(
		private menu: MenuController,
		private syncService: SyncService,
		private connectionService: ConnectionService,
		private alertController: AlertController,
		private authService: AuthService,
		public router: Router,
		private clientConfig: ClientConfigurationService,
	) { }

	get isOnline$(): Observable<boolean> {
		return this.connectionService.online$;
	}

	get currentRoute(): string {
		return this.router.url;
	}

	async ngOnInit() {
		await this.enableFeatures();
	}

	async enableFeatures(): Promise<void> {
		if (await this.clientConfig.hasFeature(ConfigSettings.ShowTimeCodeInClearCodeTab)) {
			this.routes.push({
				id: 2,
				text: 'Time Tracking',
				url: '/time-tracking',
				icon: 'alarm-outline',
			});
		}

		if (await this.clientConfig.hasFeature(ConfigSettings.UseTruck)) {
			this.routes.push({
				id: 3,
				text: 'Truck Inventory',
				url: '/truck-inventory',
				icon: 'build-outline',
			});
		}
	}

	async openMenu(): Promise<void> {
		if (!await this.menu.isOpen(this.mainMenuId)) {
			await this.menu.enable(true, this.mainMenuId);
			await this.menu.open(this.mainMenuId);
		}
	}

	async closeMenu() {
		if (await this.menu.isOpen(this.mainMenuId)) {
			await this.menu.close(this.mainMenuId);
		}
	}

	async reloadConfiguration(): Promise<void> {
		await this.closeMenu();
		await this.syncService.reloadConfiguration();
	}

	async alertOffline(): Promise<void> {
		const offlineAlert = await this.alertController.create({
			header: 'Device Offline',
			message: 'Updates from the server are currently unavailable. Please try again when your device is online.',
			buttons: ['OK'],
		});

		await offlineAlert.present();
	}

	async navigateTo(url: string): Promise<void> {
		await this.closeMenu();
		this.router.navigateByUrl(url);
	}

	logout(): void {
		this.closeMenu();
		this.authService.logout();
	}

}
